import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

import { ConfigService } from '../../../services/config.service';
import { DialogService } from '../../../services/dialog.service';
import { LoginService } from '../../../services/login.service';
import { UsersService } from '../../../services/users.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-set-email',
    templateUrl: './set-email.component.html',
    styleUrls: ['./set-email.component.scss'],
    standalone: false
})
export class SetEmailComponent implements OnInit, OnDestroy {
    constructor(
        private formBuilder: UntypedFormBuilder,
        private configService: ConfigService,
        private dialogService: DialogService,
        private loginService: LoginService,
        private usersService: UsersService,
        private router: Router,
        private route: ActivatedRoute,
        private cookieService: CookieService
    ) {}

    subscriptions: Subscription = new Subscription();

    setEmailForm: UntypedFormGroup;
    errorMessage: string;
    successMessage: string;

    userid: number;
    token: string;

    ngOnInit() {
        this.userid = +this.route.snapshot.queryParamMap.get('userid');
        this.token = this.route.snapshot.queryParamMap.get('token');
        this.setEmailForm = this.formBuilder.group({
            email: ['', Validators.required],
            confirmation_email: ['', Validators.required]
        });
        this.calculateViewportHeight();
        window.addEventListener('resize', this.calculateViewportHeight);
        window.addEventListener('orientationchange', this.calculateViewportHeight);
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    isDarkTheme() {
        return this.cookieService.get('dark') === 'true';
    }

    getHeaderText() {
        return this.configService.getConfig().header_text;
    }

    getImageTop() {
        return this.configService.getConfig().left_image_top;
    }

    getImageBottom() {
        return this.configService.getConfig().left_image_bot;
    }

    getVersion() {
        return this.configService.getConfig().version;
    }

    getRightSidePanelBackground(): any {
        return {
            'background-image': `url(${this.configService.getConfig().right_image})`
        };
    }

    setEmail(): void {
        if (this.setEmailForm.value.email === this.setEmailForm.value.confirmation_email) {
            this.subscriptions.add(
                this.usersService
                    .setEmail(this.userid, this.setEmailForm.value.email, this.token)
                    .subscribe(
                        (data: any) => {
                            this.errorMessage = '';
                            this.successMessage =
                                "Un email contenant le lien d'activation vient de vous être envoyé.";
                        },
                        (error: HttpErrorResponse) => {
                            this.errorMessage = error.error.userMessage;
                        }
                    )
            );
        } else {
            this.errorMessage = 'Les adresses email que vous avez rentrées ne sont pas identiques.';
        }
    }

    calculateViewportHeight() {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    forceNoEmail() {
        this.loginService.forceNoEmail();
    }

    goToCGU() {
        this.router.navigate(['cgu']);
    }

    openDiagnostic() {
        this.dialogService.openDiagnostic(false);
    }

    getAnchoredLogoURL() {
        return this.configService.getConfig().anchored_logo_url;
    }
}
